import React from "react";

import style from "./Safearea.scss";

export const Safearea = ({ children, ...props }) => <div className={style.safearea}>{children}</div>;
